import { render, staticRenderFns } from "./GenderbyLGA.vue?vue&type=template&id=ee413e86&"
import script from "./GenderbyLGA.vue?vue&type=script&lang=js&"
export * from "./GenderbyLGA.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports